import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import {restUrl} from "../../../../apiUrl";

export const FeedbackReq = () => {
    const {state} = useLocation();
    const navigate = useNavigate();
    axios.patch(`${restUrl}/activity_test_application?id=eq.${state.appId}`, {feedback_req:true})
        .then(_ => alert('피드백이 신청되었습니다.'))
        .catch(e=>alert(e))
        .finally(()=>navigate(-1))
}